import { Injectable } from "@angular/core";

import { UtenteDTO } from "@app/shared/dto/utenteDTO";
import { UtenteVO } from "@app/shared/vo/utenteVO";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";

import { MapperProfilo } from "@app/shared/mapper/mapper-profilo";

@Injectable({
  providedIn: "root"
})
export class MapperUtente implements MapperInterface<UtenteDTO, UtenteVO> {
  constructor(private mapperProfilo: MapperProfilo) { }

  convertVoToDto(utenteVO: UtenteVO): UtenteDTO {
    // console.log("[MapperUtente] utenteVO => utenteDTO");
    const utenteDTO = new UtenteDTO();
    if (utenteVO != null) {

      utenteDTO.id = utenteVO.id;
      utenteDTO.nome = utenteVO.nome;
      utenteDTO.cognome = utenteVO.cognome;
      utenteDTO.username = utenteVO.username;

      utenteDTO.profili = this.mapperProfilo.convertListVoToDto(utenteVO.profili);
    }
    return utenteDTO || new UtenteDTO();
  }

  convertDtoToVo(utenteDTO: UtenteDTO): UtenteVO {
    /* console.log("[MapperUtente] utenteDTO => utenteVO");
    console.log("utenteDTO", utenteDTO); */

    const utenteVO = new UtenteVO();
    if (utenteDTO) {
      utenteVO.id = utenteDTO.id;
      utenteVO.nome = utenteDTO.nome;
      utenteVO.cognome = utenteDTO.cognome;
      utenteVO.username = utenteDTO.username;

      utenteVO.profili = this.mapperProfilo.convertListDtoToVo(
        utenteDTO.profili
      );
      if (utenteVO.profili != null) {
        utenteVO.profili.forEach(profilo => {

          if (profilo.codice === "FASC") {
            utenteVO.isEstensore = true;
          }
          if (profilo.codice === "ESTENLIQ") {
            utenteVO.isEstensoreLiquidazione = true;
          }
          if (profilo.codice === "LETT") {
            utenteVO.isConsultatore = true;
          }
          if (profilo.codice === "RESP") {
            utenteVO.isResponsabile = true;
          }
          if (profilo.codice === "RGD") {
            utenteVO.isResponsabile = true;
          }

          if (profilo.codice === "REDAT") {
            utenteVO.isRedattore = true;
          }
          if (profilo.codice === "VERIF") {
            utenteVO.isVerificatore = true;
          }
          if (profilo.codice === "VERIF_CONT") {
            utenteVO.isVerificatoreContabile = true;
          }
          if (profilo.codice === "SEGRETERIA") {
            utenteVO.isSegreteria = true;
          }
          if (profilo.codice === "COLLEGIO") {
            utenteVO.isCollegio = true;
          }
        });
      }
    }
    return utenteVO || new UtenteVO();
  }

  convertListVoToDto(utenteVOList: UtenteVO[]): UtenteDTO[] {
    const utenteDTOList = new Array<UtenteDTO>();
    if (utenteVOList != null && utenteVOList.length > 0) {
      utenteVOList.forEach(ufficioVO => {
        utenteDTOList.push(this.convertVoToDto(ufficioVO));
      });
    }
    return utenteDTOList || new Array<UtenteDTO>();
  }
  convertListDtoToVo(utenteDTOList: UtenteDTO[]): UtenteVO[] {
    if (utenteDTOList !== undefined) {
      return utenteDTOList.map(dto => this.convertDtoToVo(dto));
    } else {
      return new Array<UtenteVO>();
    }
  }
}
